import { render } from "./TheHeaderPP.vue?vue&type=template&id=783b51f2"
import script from "./TheHeaderPP.vue?vue&type=script&lang=js"
export * from "./TheHeaderPP.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__